<template>
    <div class="rank-list">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="transactionDetails"
            :loading="loading"
            :menuAuth="menuAuth"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column align="left" label="Holiday Name" prop="name"
                    ><template slot-scope="scope">
                        <div>{{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Date" prop="holiday"
                    ><template slot-scope="scope">
                        <div>{{ scope.row.holiday }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Products"
                    prop="products"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Operator"
                    prop="user_name"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Created On"
                    prop="created_at"
                >
                </el-table-column>
                <el-table-column label="Operation" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg">
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add :addVisible.sync="addVisible" :funcName="funcName" :treeData="treeData"></add>
        <edit
            :editVisible.sync="editVisible"
            :funcName="funcName"
            :tableItem="tableItem"
            :treeData="treeData"
        ></edit>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import tableItemEdit from "@/common/components/table/tableItemEdit.vue";
import add from "./holidayList/add.vue";
import edit from "./holidayList/edit.vue";
export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            searchForm: {
            },
            searchForm_transfer: {
            },
            funcName: "holiday",
            addVisible: false,
            selectList: [],
            editVisible: false,
            rechargeVisible: false,
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
            },
            tableItem: {},
            treeData:[],
        };
    },
    methods: {
        add(){
            this.addVisible = true;
        },
        batchChangeStatus(item) {
        },
        // 获取尾程列表
        holiday(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            cmofferApi
                .holiday(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.closeDrawer();
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        goodsCategory() {
            cmofferApi.goodsCategory({}, "get").then((res) => {
                if (res) {
                    this.treeData = res.data;
                }
            });
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                } else if (item.funcName == "recharge") {
                    this.rechargeVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.holiday();
            this.goodsCategory();
        },
        updateItem(obj) {
            for (let i in this.tableData) {
                if (this.tableData[i].id == obj.id) {
                    this.tableData[i][Object.keys(obj)[0]] =
                        Object.values(obj)[0];
                }
            }
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        tableItemEdit,
        add,
        edit,
    },
    computed: {
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.rank-list {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
}
</style>
